import Storage from '@homeservices/tool-kit/storage/local-storage';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _isEqual from 'lodash/isEqual';
import _cloneDeep from 'lodash/cloneDeep';

// Internal Functions
// --------------------------------------------
const isChanged = keys => (pState, nState) => keys.some((val) => {
  return !_isEqual(
    _get(pState, val, null),
    _get(nState, val, null)
  );
});

const createKeyObject = keys => state => _cloneDeep(keys.reduce((acc, next) => {
  const value = _get(state, next, null);
  return _set(acc, next, value);
}, {}));

// Exposed Functions
// -----------------------------------------
export const load = ({ name }) => Storage.get(name, {});

export const clear = ({ name }) => Storage.remove(name);

export const persist = ({ keys, name }) => (store) => {
  const getWatchedObjectFromState = createKeyObject(keys);
  const compareKeysIn = isChanged(keys);
  let prevState = getWatchedObjectFromState(store.state);

  store.subscribe((mutation, state) => {
    const nextState = getWatchedObjectFromState(state);
    const requiresUpdate = compareKeysIn(prevState, nextState);

    if (requiresUpdate) {
      // Create object structure to set the keys
      const objToSave = keys.reduce((acc, next) => {
        const value = _get(state, next, null);
        return _set(acc, next, value);
      }, {});

      // Merge new updated object with object in the storage
      // and put it back into the storeage
      Storage.set(name, { ...Storage.get(name, {}), ...objToSave });
    }
    prevState = nextState;
  });
};
